/**
 * Created by Ning Jiang on 11/17/2016.
 */

require("../node_modules/gsap/src/uncompressed/plugins/PixiPlugin");

import ("pixi.js");
declare global {
    interface Window {
        PIXI:any;
    }
}

import * as PIXI from "pixi.js";
window.PIXI = PIXI;
require ("pixi-spine");

import {NolimitLauncher} from "@nolimitcity/slot-launcher/bin/NolimitLauncher";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {NolimitPromotionPlugin} from "@nolimitcity/promo-panel/bin/NolimitPromotionPlugin";
import {TombstoneNoMercy} from "./game/TombstoneNoMercy";
import {NolimitSlotAudio} from "@nolimitcity/slot-audio/bin/NolimitSlotAudio";
import {TombstonePromoPanelConfig} from "./game/TombstonePromoPanelConfig";
import {TBNoMercyIntroConfig} from "./game/intro/TBNoMercyIntroConfig";
import {NolimitGameIntroPlugin} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/NolimitGameIntroPlugin";

declare global {
    interface Window { NolimitLauncher: NolimitLauncher;}
}
window.NolimitLauncher = NolimitLauncher.instance;
NolimitLauncher.instance.launch([
    new TombstoneNoMercy(),
    new SlotKeypad(),
    new NolimitPromotionPlugin(new TombstonePromoPanelConfig()),
    new NolimitGameIntroPlugin(new TBNoMercyIntroConfig()),
    new NolimitSlotAudio()
]);